import moment from "moment";
import { addEditEventsConst } from "./addEvents.constants";
export const getLocalTimeZoneCode = () => {
  const timeZoneId = moment.tz.guess();
  return {
    timeZoneId,
    code: moment.tz(timeZoneId).format("z")?.trim(),
  };
};

export const hasTimeChanged = (alreadyTime, selectedTime) => {
  if (!alreadyTime) return true;
  const selectedStartTime = moment(selectedTime);
  const alreadySelectedStartTime = moment(alreadyTime);
  return (
    selectedStartTime.hour() !== alreadySelectedStartTime.hour() ||
    selectedStartTime.minute() !== alreadySelectedStartTime.minute()
  );
};
export function getOrdinal(number) {
  const v = number % 100;

  if (v >= 11 && v <= 13) {
    return number + "th";
  }

  switch (number % 10) {
    case 1:
      return number + "st";
    case 2:
      return number + "nd";
    case 3:
      return number + "rd";
    default:
      return number + "th";
  }
}
export const arrayIntoString = (curr = []) => {
  return curr.reduce((prev, curr, ind, currArr) => {
    if (!ind) {
      return curr;
    }
    return prev + (ind && ind === currArr.length - 1 ? " & " : ", ") + curr;
  }, "");
};
export const MoreTagsFunction = ({
  value,
  styles,
  clickHandler,
  mapFn,
  lastIndex = 3,
  parentClass,
  hideMore = true,
}) => {
  if (value?.length === 0) {
    return null;
  }
  return (
    <span className={parentClass}>
      {value.slice(0, lastIndex).map(mapFn).join(", ")}
      {hideMore && value?.length > lastIndex && (
        <>
          ,
          <span
            type="button"
            className={`${styles} link-btn`}
            onClick={clickHandler}
          >
            +{value?.length - lastIndex} More
          </span>
        </>
      )}
    </span>
  );
};
const addWeekNames = (values) => {
  return addEditEventsConst.onTheWeekdays.reduce((prev, res) => {
    if (values.includes(res.id)) {
      if (prev) {
        prev += ", " + res.name;
      } else {
        prev += res.name;
      }
    }
    return prev;
  }, "");
};
export const getRepeatMessage = ({
  repeatedTypeEvery,
  repeatOptionsFrequency,
  repeatedTypeFrequency,
  getSelectedDayNames,
  selectionType,
  selectedSlotDate,
  selectedWeek,
  selectedDay,
  selectedMonths,
  isDaySwitchOn,
  isFromBusySlot = false,
  isShift = false,
  repeatedType
}) => {
  if (!repeatedTypeEvery || (repeatedType&&repeatedType === addEditEventsConst.repeatedOptionsValues.never)) return null;
  const whichType = repeatOptionsFrequency
    .find((res) => res.id === repeatedTypeFrequency)
    .showType.toLowerCase();
  const value = `${
    isFromBusySlot ? "Busy Slot" : isShift ? "Shift" : "Event"
  } will occur every ${repeatedTypeEvery} ${whichType}${
    repeatedTypeEvery > 1 ? "s" : ""
  }`;
  switch (repeatedTypeFrequency) {
    // message for daily
    case addEditEventsConst.repeatOptionsFrequency[0].id:
      return value + ".";
    case addEditEventsConst.repeatOptionsFrequency[1].id: {
      // message for week days selection
      const selectedDays = getSelectedDayNames();

      return value + `${selectedDays ? ` on ${selectedDays}` : ""}.`;
    }
    case addEditEventsConst.repeatOptionsFrequency[2].id: {
      // selection type only enabled when user select days from Each tab
      // it gets false when user select On The... radio
      if (selectionType) {
        return (
          value +
          `${
            selectedSlotDate.length
              ? ` on ${arrayIntoString(
                  [...selectedSlotDate]
                    ?.sort((a, b) => a - b)
                    .map((res) => getOrdinal(res))
                )}`
              : ""
          }.`
        );
      }

      return (
        value +
        `${
          selectedWeek > 5
            ? " on " +
              addEditEventsConst.firstToLast
                .find((res) => res.id === selectedWeek)
                .name.toLowerCase()
            : " on " + getOrdinal(selectedWeek)
        } ${addWeekNames(addWeekDayOrWeekend(selectedDay))}.`
      );
    }
    case addEditEventsConst.repeatOptionsFrequency[3].id: {
      const selectedMonthsText =
        selectedMonths.length > 0
          ? arrayIntoString(
              [...addEditEventsConst.forYearlyMonthsArray]
                .sort((a, b) => a.id - b.id)
                .reduce((p, r) => {
                  if (selectedMonths.includes(r.id)) {
                    p.push(r.name);
                  }
                  return p;
                }, [])
            )
          : "";
      if (isDaySwitchOn) {
        return (
          value +
          ` on the ${
            selectedWeek > 5
              ? addEditEventsConst.firstToLast
                  .find((res) => res.id === selectedWeek)
                  .name.toLowerCase()
              : getOrdinal(selectedWeek)
          } ${addWeekNames(
            addWeekDayOrWeekend(selectedDay)
          )} of ${selectedMonthsText}.`
        );
      }
      return value + (selectedMonthsText ? ` on ${selectedMonthsText}.` : "");
    }
    default:
      break;
  }
  return null;
};

export const displayCustomMessage = (eventDetails, isFromBusySlot = false) => {
  if((eventDetails?.repeatedType&&eventDetails?.repeatedType === addEditEventsConst.repeatedOptionsValues.never)) return null;
  const values = eventDetails.customRepeatPattern;
  const getSelectedDayNames = () => {
    if (values?.daysOfWeek?.length === 0) return "";
    const sortedDays = values?.daysOfWeek
      .map((val) => addEditEventsConst.dayMap[val.dayOfWeek])
      .sort((a, b) => a - b);

    return arrayIntoString(sortedDays);
  };
  const repeatOptionsFrequency = addEditEventsConst.repeatOptionsFrequency;
  return getRepeatMessage({
    repeatedTypeEvery: values.interval,
    repeatOptionsFrequency,
    repeatedTypeFrequency: values.unit,
    getSelectedDayNames,
    selectionType: values.unit === 3 && !!values.daysOfMonth.length,
    selectedSlotDate: values?.daysOfMonth
      ?.map((res) => res.day)
      ?.sort((a, b) => a - b),
    selectedWeek: values?.monthWeekNumber ?? 1,
    selectedDay:
      [repeatOptionsFrequency[2].id, repeatOptionsFrequency[3].id].includes(
        values.unit
      ) && values.daysOfWeek.length
        ? getSelectedDayValueForWeekdayOrWeekend(
            values.daysOfWeek.map((res) => res.dayOfWeek)?.sort((a, b) => a - b)
          )
        : 1,
    selectedMonths: values?.monthsOfYear
      ?.map((res) => res.month)
      ?.sort((a, b) => a - b),
    isDaySwitchOn:
      values.unit === 4 &&
      values.monthsOfYear.length > 0 &&
      values.daysOfWeek.length > 0,
    isFromBusySlot,
    isShift: eventDetails?.isShift,
  });
};
export const getSelectedDayValueForWeekdayOrWeekend = (daysOfWeek) => {
  switch (daysOfWeek?.length) {
    case 1:
      return daysOfWeek[0];
    case 2:
      return addEditEventsConst.onTheWeekdays[8].id;
    default:
      return addEditEventsConst.onTheWeekdays[7].id;
  }
};

const addWeekDayOrWeekend = (selectedDay) => {
  switch (selectedDay) {
    case addEditEventsConst.onTheWeekdays[7].id:
      return [1, 2, 3, 4, 5];
    case addEditEventsConst.onTheWeekdays[8].id:
      return [6, 7];
    default:
      return [selectedDay];
  }
};
export const matchBothLength = (match, matchwith) => {
  return (
    match?.filter((res) => {
      if (res.IsDeleted || res.isDeleted) {
        return false;
      }
      return true;
    })?.length !== matchwith?.length
  );
};
export const matchedBothDatesValues = ({
  eventDetail,
  repeatedEndDate,
  requestedDate,
  eventDate,
}) => {
  const neverCheck =
    eventDetail?.repeatedType ===
    addEditEventsConst.repeatedOptionsValues.never;
  const values = {
    startDateChanged: false,
    endDateChanged: false,
  };
  if (neverCheck && !moment(eventDate).isSame(moment(eventDetail?.date))) {
    values.startDateChanged = true;
  }
  if (neverCheck) return values;
  if (
    eventDetail?.repeatedEndDate &&
    !moment(repeatedEndDate).isSame(moment(eventDetail?.repeatedEndDate))
  ) {
    values.endDateChanged = true;
  }
  if (requestedDate) {
    if (!moment(requestedDate).isSame(moment(eventDate))) {
      values.startDateChanged = true;
    }
  } else if (!moment(eventDate).isSame(moment(eventDetail?.date))) {
    values.startDateChanged = true;
  }
  return values;
};

// check for if any changes reflected in pattern
export const matchedBothPatternValues = ({
  repeatedType,
  repeatedTypeFrequency,
  repeatedTypeEvery,
  selectionType,
  schedule,
  selectedSlotDate,
  selectedWeek,
  selectedDay,
  selectedMonths,
  isDaySwitchOn,
  edit = false,
  eventDetail,
}) => {
  const repeatChanged = repeatedType !== eventDetail?.repeatedType;
  if (repeatChanged) return true;

  if (repeatedType === addEditEventsConst.repeatedOptionsValues.custom) {
    const params = {};

    setterCustomSchduler({
      params,
      repeatedType,
      repeatedTypeFrequency,
      repeatedTypeEvery,
      selectionType,
      schedule,
      selectedSlotDate,
      selectedWeek,
      selectedDay,
      selectedMonths,
      isDaySwitchOn,
      edit,
      eventDetail,
    });

    const currentValues = {
      Unit: params.CustomRepeatPattern?.Unit,
      Interval: params.CustomRepeatPattern?.Interval,
      DaysOfMonth: params.CustomRepeatPattern?.DaysOfMonth ?? [],
      DaysOfWeek: params.CustomRepeatPattern?.DaysOfWeek ?? [],
      MonthsOfYear: params.CustomRepeatPattern?.MonthsOfYear ?? [],
      monthWeekNumber: params.CustomRepeatPattern?.monthWeekNumber ?? null,
    };

    const savedValues = eventDetail?.customRepeatPattern;

    if (!savedValues) {
      return Object.values(currentValues).some((value) =>
        Array.isArray(value) ? value.length > 0 : value !== null
      );
    }

    // Compare Unit and Interval
    if (
      currentValues.Unit !== savedValues.unit ||
      currentValues.Interval !== savedValues.interval
    ) {
      return true;
    }

    // Compare DaysOfMonth
    const savedDaysOfMonth = savedValues.daysOfMonth?.map((d) => d.day) ?? [];
    if (!arraysEqual(currentValues.DaysOfMonth, savedDaysOfMonth)) {
      return true;
    }

    // Compare DaysOfWeek
    const savedDaysOfWeek =
      savedValues.daysOfWeek?.map((d) => d.dayOfWeek) ?? [];
    if (!arraysEqual(currentValues.DaysOfWeek, savedDaysOfWeek)) {
      return true;
    }

    // Compare MonthsOfYear
    const savedMonthsOfYear =
      savedValues.monthsOfYear?.map((d) => d.month) ?? [];
    if (!arraysEqual(currentValues.MonthsOfYear, savedMonthsOfYear)) {
      return true;
    }

    // Compare monthWeekNumber
    if (currentValues.monthWeekNumber !== savedValues.monthWeekNumber) {
      return true;
    }
  }

  return false;
};

// Utility function for array comparison
const arraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  return arr1.every((item) => arr2.includes(item));
};
export const setterCustomSchduler = ({
  params,
  repeatedType,
  repeatedTypeFrequency,
  repeatedTypeEvery,
  selectionType,
  schedule,
  selectedSlotDate,
  selectedWeek,
  selectedDay,
  selectedMonths,
  isDaySwitchOn,
  edit = false,
  eventDetail = {},
}) => {
  if (+repeatedType === addEditEventsConst.repeatedOptionsValues.custom) {
    if (edit) {
      params.customRepeatPatternId = eventDetail?.customRepeatPatternId;
    }
    params.CustomRepeatPattern = {};
    params.CustomRepeatPattern.Unit = repeatedTypeFrequency;
    params.CustomRepeatPattern.Interval = repeatedTypeEvery;
    switch (repeatedTypeFrequency) {
      // for weekly frequency
      case 2:
        params.CustomRepeatPattern.DaysOfWeek = schedule;
        break;
      // for monthly frequency
      case 3:
        // for calendar dates
        if (selectionType) {
          params.CustomRepeatPattern.DaysOfMonth = selectedSlotDate;
        } else {
          // for  every number of days and weeekday
          params.CustomRepeatPattern.monthWeekNumber = selectedWeek;
          params.CustomRepeatPattern.DaysOfWeek =
            addWeekDayOrWeekend(selectedDay);
        }
        break;
      case 4:
        // for  month
        params.CustomRepeatPattern.MonthsOfYear = selectedMonths;
        if (isDaySwitchOn) {
          // for  every number of days and weeekday
          params.CustomRepeatPattern.monthWeekNumber = selectedWeek;
          params.CustomRepeatPattern.DaysOfWeek =
            addWeekDayOrWeekend(selectedDay);
        }
        break;
      default:
        break;
    }
  }
};
const mappingForOfficeInvitee = (office, edit) => {
  if (edit) {
    return {
      id: office?.externalId ?? office?.id,
      officeId: office.officeId,
      isDeleted: office.isDeleted,
    };
  }
  return {
    id: 0,
    officeId: office.officeId,
    isDeleted: office.isDeleted,
  };
};
export const setterPublishOffices = ({
  preferredOption,
  userIds,
  publishAsEvent,
  nonInviteesPublish,
  params,
  officeIdForNonInvitee,
  edit = false,
  isDraft = false,
}) => {
  if (
    preferredOption.dropdown[
      edit && !isDraft && !userIds?.length ? 0 : userIds?.length ? 1 : 0
    ].id === publishAsEvent
  ) {
    params.publishedType = nonInviteesPublish;
    if (
      nonInviteesPublish ===
      preferredOption.otherOptions[userIds?.length ? 2 : 1].id
    ) {
      params.schedulerEventPublishedOffice = officeIdForNonInvitee.map((res) =>
        mappingForOfficeInvitee(res, edit)
      );
    } else {
      params.schedulerEventPublishedOffice = officeIdForNonInvitee.map((res) =>
        mappingForOfficeInvitee({ ...res, isDeleted: true }, edit)
      );
    }
  }
};
export const setterValuesAddedFilter = (setter, value) => {
  setter((prevSelected) => {
    if (prevSelected.length === 1 && prevSelected.includes(value)) {
      return prevSelected;
    }
    return prevSelected.includes(value)
      ? prevSelected.filter((m) => m !== value).sort((a, b) => a - b)
      : [...prevSelected, value].sort((a, b) => a - b);
  });
};
export const addRemoveUserOrRoleError = ({
  filteredUserIds,
  errorsData,
  designationIds,
  t,
  isValid = false,
}) => {
  if (!filteredUserIds.length && !designationIds.length) {
    errorsData["staffMembers"] = t("form.errors.emptySelection", {
      field: t("accountOwner.employees"),
    });
    errorsData["roles"] = t("form.errors.emptySelection", {
      field: t("roles"),
    });
    return false;
  } else {
    delete errorsData["staffMembers"];
    delete errorsData["roles"];
    return isValid;
  }
};
export const handleSubmitValidation = ({
  errors,
  eventCheck,
  title,
  t,
  isAllDayEvent,
  startTime,
  endTime,
  filteredUserIds,
  designationIds,
  repeatedType,
  preferredOption,
  eventDate,
  repeatedEndDate,
  publishAsEvent,
  nonInviteesPublish,
  officeIdForNonInvitee,
  setErrors,
  edit = false,
  isDraft = false,
}) => {
  let isValid = true;

  let errorsData = JSON.parse(JSON.stringify(errors));

  if (eventCheck && (title.trim().length === 0 || title.trim().length > 400)) {
    if (title.trim().length > 400) {
      errorsData.title = t("form.errors.maxLimit", { limit: "400" });
      isValid = false;
    } else if (title.trim().length == 0) {
      errorsData.title = t("form.errors.emptyField", { field: t("title") });
      isValid = false;
    } else {
      delete errorsData["title"];
    }
  }

  if (!isAllDayEvent) {
    if (!startTime && endTime) {
      errorsData["startTime"] = t("form.errors.emptySelection", {
        field: t("staff.startTime"),
      });
      isValid = false;
      delete errorsData["endTime"];
    } else if (startTime && !endTime) {
      errorsData["endTime"] = t("form.errors.emptySelection", {
        field: t("staff.endTime"),
      });
      isValid = false;
      delete errorsData["startTime"];
    } else if (startTime && endTime) {
      const duration = moment
        .duration(moment(endTime).diff(moment(startTime)))
        .asMinutes();
      if (duration >= 1) {
        delete errorsData["endTime"];
      } else {
        errorsData["endTime"] = t("form.errors.endTimeShouldBeGreater");
        isValid = false;
      }
    } else {
      errorsData["startTime"] = t("form.errors.emptySelection", {
        field: t("staff.startTime"),
      });
      errorsData["endTime"] = t("form.errors.emptySelection", {
        field: t("staff.endTime"),
      });
      isValid = false;
    }
  } else {
    delete errorsData["startTime"];
    delete errorsData["endTime"];
  }
  isValid = addRemoveUserOrRoleError({
    filteredUserIds,
    designationIds,
    errorsData,
    t,
    isValid,
  });

  if (repeatedType !== 1) {
    let startDate = moment(eventDate).format("YYYY-MM-DD");
    let endDate = moment(repeatedEndDate).format("YYYY-MM-DD");
    if (!moment(startDate).isBefore(endDate) && startDate != endDate) {
      isValid = false;
      errorsData["repeatedEndDate"] = t("form.errors.endGreater");
    }
  }

  if (
    preferredOption.dropdown[
      edit && !isDraft && !filteredUserIds?.length
        ? 0
        : filteredUserIds.length
        ? 1
        : 0
    ].id === publishAsEvent &&
    nonInviteesPublish ===
      preferredOption.otherOptions[filteredUserIds.length ? 2 : 1].id &&
    !officeIdForNonInvitee.length
  ) {
    errorsData["nonInvitee"] = t("form.errors.emptySelection", {
      field: t("accountOwner.officeForPublishing"),
    });
    isValid = false;
  } else {
    delete errorsData["nonInvitee"];
  }
  setErrors(errorsData);
  return isValid;
};

export const handleChangeValidation = ({
  key,
  value,
  errors,
  t,
  setIsAllDayEvent,
  setStartTime,
  setEndTime,
  endTime,
  updateTimeToUpcomingQuater,
  startTime,
  setErrors,
}) => {
  let errorsData = JSON.parse(JSON.stringify(errors));
  switch (key) {
    case "title": {
      if (value.trim().length > 400) {
        errorsData.title = t("form.errors.maxLimit", { limit: "400" });
      } else if (value.trim().length == 0) {
        errorsData.title = t("form.errors.emptyField", { field: t("title") });
      } else {
        delete errorsData["title"];
      }
      break;
    }
    case "allDay": {
      setIsAllDayEvent(value);
      if (value) {
        setStartTime(null);
        setEndTime(null);
        delete errorsData["startTime"];
        delete errorsData["endTime"];
      }
      break;
    }
    case "eventLocation": {
      if (value.trim().length > 400) {
        errorsData.eventLocation = t("form.errors.maxLimit", {
          limit: "400",
        });
      } else if (value.trim().length == 0) {
        errorsData.eventLocation = t("form.errors.emptyField", {
          field: t("location"),
        });
      } else {
        delete errorsData["eventLocation"];
      }
      break;
    }
    case "startTime": {
      const newStartTimeSlot = value;
      setStartTime(newStartTimeSlot);
      if (value && endTime) {
        const duration = moment
          .duration(moment(endTime).diff(moment(value)))
          .asMinutes();
        if (duration < 1) {
          setEndTime(moment(newStartTimeSlot).add(1, "minutes"));
        }
        delete errorsData["endTime"];
      }
      break;
    }
    case "endTime": {
      const newEndTimeSlot = updateTimeToUpcomingQuater(value);
      setEndTime(newEndTimeSlot);
      if (startTime) {
        const duration = moment
          .duration(moment(newEndTimeSlot).diff(moment(startTime)))
          .asMinutes();
        if (duration >= 1) {
          delete errorsData["endTime"];
        } else {
          errorsData["endTime"] = t("form.errors.endTimeShouldBeGreater");
        }
      }
      break;
    }
    default:
      break;
  }
  setErrors(errorsData);
};
export const renderOfficeNameOrEnterprise = (item, t) => {
  if (item?.isEnterprise) {
    return t("scheduler.enterprise");
  } else {
    return (
      item?.eventEmployeeOfficeName ||
      item?.officeName ||
      item?.officeName ||
      item?.officeNameList ||
      null
    );
  }
};
